import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import React from 'react';
import { AdminUser } from 'src/types/shared/AdminUser';
import useUpdateAdminPassword from './hooks/useUpdateAdminPassword';

const UpdateAdminPasswordModal: React.FC<UpdateAdminPasswordProps> = ({ user: { id } }) => {
    const {
        formState: { password, confirmPassword },
        handleChange,
        handleSubmit,
        closeModal,
        initForm,
    } = useUpdateAdminPassword(id);
    const { validatePassword, validateConfirmPassword } = usePasswordValidation(password);

    return (
        <Modal title="Update password" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} onInit={initForm}>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="password"
                        value={password}
                        onChange={handleChange}
                        label="Password"
                        customValidate={validatePassword}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleChange}
                        customValidate={validateConfirmPassword}
                        label="Confirm password"
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface UpdateAdminPasswordProps {
    user: AdminUser;
}

export default UpdateAdminPasswordModal;
